import React/*0, { Component }*/ from 'react';
//import {Container,Row, Col} from 'reactstrap';
//import {withRouter} from "react-router-dom";
//import Modes from "../exercises/mode/Modes";
//import ModeItem from "./modeItem/ModeItem";
//import {getRandomIntegerWithRange} from "../exercises/Random";
//import {formatNumberForDisplay} from "../ui/NumberFormatter";
//import DebugHelperElement from "./DebugHelperElement";
//import ArithmeticElement from "./modes/ArithmeticElement";
//import NumberSystems from "../exercises/NumberSystems";
//import KeyboardElement from "./keyboard/KeyboardElement";
//import Constants from "./constants";
import "../success-checkmark.css"
class SuccessElement extends React.Component{

/*    constructor(props){
        super(props);
    }
*/
    render(){
        return <div className="success-checkmark-container">
            <div className="success-checkmark">
                <div className="check-icon">
                    <span className="icon-line line-tip"/>
                    <span className="icon-line line-long"/>
                    <div className="icon-circle"/>
                    <div className="icon-fix"/>
                </div>
            </div>
        </div>
    }
}
export default SuccessElement